/**
 * Lightweight token storage with client-side expiration.
 *
 * Defense-in-depth on top of the server-side 7-day rolling TTL: even if a token
 * is stolen via XSS, it self-expires on the client after `MAX_AGE_MS` (24h).
 * The server remains the source of truth — any expired/invalid token is
 * rejected with 401 and the UI redirects back to the login screen.
 */
const TOKEN_KEY = "pine_admin_token";
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24h

export function saveToken(token) {
  try {
    localStorage.setItem(
      TOKEN_KEY,
      JSON.stringify({ token, exp: Date.now() + MAX_AGE_MS })
    );
  } catch {
    /* localStorage unavailable (private mode) — ignore, session-only */
  }
}

export function readToken() {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    if (!raw) return "";
    // Backwards-compat: tolerate previously-stored bare token strings.
    if (!raw.startsWith("{")) return raw;
    const { token, exp } = JSON.parse(raw);
    if (!token || !exp || Date.now() > exp) {
      localStorage.removeItem(TOKEN_KEY);
      return "";
    }
    return token;
  } catch {
    return "";
  }
}

export function clearToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}
